/**
 * 跳转链接
 */
import { i18n } from '@/locales/i18n';
import { jumpAppPage } from './appBridge';

export const locale = i18n.global.locale.value;

const { isApp, isMobile } = window.sfe;

export const toVipProgram = (newTab) => {
    if (isApp) {
        jumpAppPage({ path: 'by-mini://vip/home?from_type=crypto_loan' });
        return;
    }
    const link = `/${locale}/VIPProgram?from_type=crypto_loan`;
    if (newTab) {
        window.open(link, '_blank');
    } else {
        window.location.href = link;
    }
};

export const toLogin = (redirect, toDemoAccount) => {
    let url = `/${locale}/login`;
    if (toDemoAccount) {
        url = `/${locale}/login?demoAccount=true`;
    }
    if (redirect) {
        url = `${url}${url.includes('?') ? '&' : '?'}redirect_url=${encodeURIComponent(redirect)}`;
    }
    window.location.href = url;
};

// H5唤起App内质押借币页
export const toAppLoan = () => {
    if (isMobile) {
        window.byAppsFlyers?.triggerOneLink(`bybitapp://open/route?targetUrl=${encodeURIComponent('/spot/borrow/home')}`);
    }
};
